import React from 'react';

const AnchorMenu = props => {
  const { data } = props;
  const anchorBlocks = data.filter(
    b => b.content.anchor && b.content.anchor.status,
  );
  const anchors = anchorBlocks.map((a, index) => {
    return (
      <div key={`${a.type}_${a.sort}`} className="menu__item txt--sm">
        <a
          className={index ? 'menu__link' : 'menu__link menu__link--active'}
          href={`#${a.type}_${a.sort}`}
        >
          {a.content.anchor.text}
        </a>
      </div>
    );
  });

  return (
    <div className="menu">
      <div className="container menu__container">
        <nav className="menu__items">{anchors}</nav>
      </div>
    </div>
  );
};

export default AnchorMenu;
